import { render, staticRenderFns } from "./SelectedSeriesCard.vue?vue&type=template&id=842c1e2a"
import script from "./SelectedSeriesCard.vue?vue&type=script&lang=js"
export * from "./SelectedSeriesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports